import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';

import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';

import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerOffIcon from '@mui/icons-material/TimerOff';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,

    },
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
}));

const OpenHoursList = props => {

    const classes = useStyles();
    const [dense, setDense] = React.useState(false);
    const [secondary, setSecondary] = React.useState(false);

    useEffect(() => {
        console.log('props', props);
    }, [props]);

    const deleteOpenHourItem = (id) => {
        props.deleteOpenHourItem(id);
    }

    const deleteCloseDateItem = (date) => {
        props.deleteCloseDateItem(date);
    }




    return (

        <div className={classes.root}>



            {props.openHoursItems && props.openHoursItems.length > 0 ?
                <Grid item lg={3}
                    sm={6}
                    xl={3}
                    xs={12}>
                    <Typography variant="h6" className={classes.title}>
                        Open Hours
          </Typography>

                    <List>
                        {props.openHoursItems.map(item => {
                            return (
                                <ListItem key={item.id}>
                                    <ListItemAvatar>

                                        <AccessTimeIcon />

                                    </ListItemAvatar>
                                    <Typography variant="h6" style={{ display: 'inline-block' }}>
                                        {item.weekdays.join(',')}
                                        {`${item.openStart} - ${item.openEnd}`}
                                    </Typography>


                                    <IconButton edge="end" aria-label="delete" onClick={() => deleteOpenHourItem(item.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                    <ListItemSecondaryAction>

                                    </ListItemSecondaryAction>
                                </ListItem>)
                        })}
                    </List>

                </Grid>
                : null}

            {props.closeDaysItems && props.closeDaysItems.length > 0 ?
                <Grid item lg={3}
                    sm={6}
                    xl={3}
                    xs={12}>
                    <Typography variant="h6" className={classes.title}>
                        Close Dates
          </Typography>
                    <div className={classes.demo}>
                        <List dense={dense}>
                            {props.closeDaysItems.map(item => {
                                return (
                                    <ListItem  key={item}>
                                        <ListItemAvatar>

                                            <TimerOffIcon />

                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={item}
                                        />
                                        <ListItemSecondaryAction>
                                            <IconButton edge="end" aria-label="delete" onClick={() => deleteCloseDateItem(item)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>)
                            })}
                        </List>
                    </div>
                </Grid>
                : null}


        </div>
    );
};

export default OpenHoursList;